"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Anchor = exports.TextAnchor = void 0;
const Area_1 = require("../../../Area");
const Point_1 = require("./Point");
const Rotation_1 = require("./Rotation");
var TextAnchor;
(function (TextAnchor) {
    TextAnchor["Start"] = "start";
    TextAnchor["End"] = "end";
})(TextAnchor || (exports.TextAnchor = TextAnchor = {}));
var Anchor;
(function (Anchor) {
    Anchor[Anchor["TopRight"] = 0] = "TopRight";
    Anchor[Anchor["TopLeft"] = 1] = "TopLeft";
    Anchor[Anchor["BottomLeft"] = 2] = "BottomLeft";
    Anchor[Anchor["BottomRight"] = 3] = "BottomRight";
    Anchor[Anchor["MiddleLeft"] = 4] = "MiddleLeft";
    Anchor[Anchor["MiddleRight"] = 5] = "MiddleRight";
})(Anchor || (exports.Anchor = Anchor = {}));
class Label {
    static fromEagleAttribute(t, element) {
        let point = new Point_1.Point(t._attributes.x, t._attributes.y);
        let rot = t._attributes.rot;
        let mirrored = false;
        if (rot?.startsWith('M')) {
            mirrored = true;
            rot = rot.substr(1);
        }
        let rotation = (0, Rotation_1.parseRotationFromDegrees)(rot);
        let { anchor, drawDownXAxis } = Label.getDrawDirection(rotation);
        let value = t._attributes.value;
        if (!value && 'NAME' === t._attributes.name) {
            value = element._attributes.name;
        }
        const result = new Label(point, parseFloat(t._attributes.size), parseInt(t._attributes.layer), value, drawDownXAxis, anchor, mirrored);
        result.hidden = 'off' === t._attributes.display;
        return result;
    }
    static fromEagleText(t, parent) {
        let point = new Point_1.Point(t._attributes.x, t._attributes.y);
        let rot = t._attributes.rot;
        let mirrored = false;
        if (rot?.startsWith('M')) {
            mirrored = true;
            rot = rot.substr(1);
        }
        let rotation = (0, Rotation_1.parseRotationFromDegrees)(rot);
        if (parent) {
            point = point.rotate(parent.rotation);
            point.add(parent.point);
            rotation = (0, Rotation_1.combineRotations)(rotation, parent.rotation);
        }
        let { anchor, drawDownXAxis } = Label.getDrawDirection(rotation);
        return new Label(point, parseFloat(t._attributes.size), parseInt(t._attributes.layer), t._text, drawDownXAxis, anchor, mirrored);
    }
    constructor(p, size, layer, value, drawDownXAxis, anchor, mirrored) {
        this.point = p;
        this.size = size;
        this.layer = layer;
        this.value = value;
        this.drawDownXAxis = drawDownXAxis;
        this.anchor = anchor;
        this.mirrored = mirrored;
        this.dominantBaseline = this.getDominantBaseline();
        this.anchorText = this.getTextAnchor();
    }
    getArea() {
        let a = new Area_1.default();
        a.extend([this.point.x, this.point.y]);
        return a;
    }
    getDominantBaseline() {
        switch (this.anchor) {
            case Anchor.MiddleRight:
            case Anchor.MiddleLeft:
                return 'middle';
            case Anchor.TopRight:
            case Anchor.TopLeft:
                return 'hanging';
            case Anchor.BottomLeft:
            case Anchor.BottomRight:
            default:
                return 'baseline';
        }
    }
    getTextAnchor() {
        switch (this.anchor) {
            case Anchor.BottomRight:
            case Anchor.MiddleRight:
            case Anchor.TopRight:
                return 'end';
            case Anchor.TopLeft:
            case Anchor.MiddleLeft:
            case Anchor.BottomLeft:
            default:
                return 'start';
        }
    }
    static getDrawDirection(rotation) {
        let drawDownXAxis = true;
        let anchor;
        switch (rotation) {
            case Rotation_1.Rotation.R90:
                anchor = Anchor.BottomLeft;
                drawDownXAxis = false;
                break;
            case Rotation_1.Rotation.R180:
                anchor = Anchor.TopRight;
                drawDownXAxis = true;
                break;
            case Rotation_1.Rotation.R270:
                anchor = Anchor.TopRight;
                drawDownXAxis = false;
                break;
            case Rotation_1.Rotation.R0:
            default:
                anchor = Anchor.BottomLeft;
                drawDownXAxis = true;
                break;
        }
        return { anchor, drawDownXAxis };
    }
}
exports.Label = Label;
//# sourceMappingURL=Label.js.map